module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1034-162bba2ecb87ae3171b376841f4c4b69.png";